import { DATE_FORMAT_MMMM_YYYY } from 'constants/formats';
import { t } from 'i18next';

import { IPersonnelProfiles } from 'components/BusinessToolForm/Sections/ManagementAndOrganization/ManagementTeam/utils/form';

import { hasMeaningfulValues } from 'helpers/hasMeaningfulValues';

import { ITeamMemberInfo } from '../types';
import { formatDate } from '../utils';

export const prepareTeamMemberCardInfo = (rawData: IPersonnelProfiles): ITeamMemberInfo | null => {
  const preparedData = {
    fullName: `${rawData.name} ${rawData.surname}`.trim(),
    position: rawData.position,
    photoSrc: rawData.file.length ? rawData.file[0].url : null,
    dateOfBirth: rawData.dateOfBirth ? formatDate(rawData.dateOfBirth) : null,
    education: rawData.listOfInstitutions
      .filter(({ name, specialization }) => name && specialization)
      .map(({ name, specialization }) => [name, specialization].join(', '))
      .join('\n'),
    workExperience: rawData.workExperience
      .filter(({ from, position, functions }) => from && position && functions)
      .map(
        ({ from, to, Employer, position, functions }) =>
          `${formatDate(from, DATE_FORMAT_MMMM_YYYY)}${to ? ` — ${formatDate(to, DATE_FORMAT_MMMM_YYYY)}` : `— ${t('present')}`}, ${Employer}, ${position}\n${functions}`,
      )
      .join('\n'),
    keySkills: rawData.keySkills,
    achievements: rawData.achievements,
  };

  return hasMeaningfulValues(preparedData) ? preparedData : null;
};

export const prepareTeamMemberCardsInfo = (rawData: IPersonnelProfiles[]): ITeamMemberInfo[] | null => {
  if (!rawData?.length) {
    return null;
  }

  return rawData.map(prepareTeamMemberCardInfo).filter((card): card is ITeamMemberInfo => !!card);
};
